import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { ActivityReply } from "../../../api/generated";
import { activityReplyKeys } from "./queryKey";

export const useSyncActivityReplyCache = () => {
    const queryClient = useQueryClient();

    // キャッシュの同期をとる
    const syncActivityReplyCache = useCallback(
        (updatedActivityReply: ActivityReply) => {
            // Activity単位
            const activityQueryKey = activityReplyKeys.activity(
                updatedActivityReply.activityId
            );
            const activityReplies =
                queryClient.getQueryData<ActivityReply[]>(activityQueryKey);
            if (activityReplies) {
                const newArray = [...activityReplies];
                const targetIndex = newArray.findIndex(
                    (x) => x.id === updatedActivityReply.id
                );
                newArray[targetIndex] = updatedActivityReply;
                queryClient.setQueryData(activityQueryKey, newArray);
            }

            // 詳細単位
            const detailQueryKey = activityReplyKeys.detail(
                updatedActivityReply.id
            );
            const detailActivityReply =
                queryClient.getQueryData<ActivityReply[]>(detailQueryKey);
            if (detailActivityReply) {
                queryClient.setQueryData(detailQueryKey, updatedActivityReply);
            }

            // 未読ステータス
            const unreadStatusQueryKey = activityReplyKeys.unreadStatus;
            const unreadStatus = queryClient.getQueryData<
                {
                    activityReplyId: string;
                    isUnread: boolean;
                }[]
            >(unreadStatusQueryKey);
            if (unreadStatus && unreadStatus.length > 0) {
                const newArray = [...unreadStatus];
                const targetIndex = newArray.findIndex(
                    (x) => x.activityReplyId === updatedActivityReply.id
                );
                newArray[targetIndex] = {
                    activityReplyId: updatedActivityReply.id,
                    isUnread: updatedActivityReply.isUnread,
                };
                queryClient.setQueryData(unreadStatusQueryKey, newArray);
            }
        },
        [queryClient]
    );

    return {
        syncActivityReplyCache,
    };
};
